import React from "react";
import Reveal from "./Reveal";
import { INSIDE } from "../../data/mock";

export default function Brotherhood() {
  return (
    <section id="inside" className="relative py-28 md:py-40 border-b hairline">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 text-[var(--text-muted)] mb-8">
          <span className="h-px w-8 bg-[var(--line-2)]"></span>
          <span className="font-mono text-[10px] uppercase tracking-[0.3em]">Inside the Brotherhood</span>
        </div>
        <Reveal>
          <h2 className="font-display text-[54px] md:text-[100px] leading-[0.96] tracking-[-0.03em]">
            What you actually <span className="italic-serif text-[var(--ember-3)]">get</span>.
          </h2>
        </Reveal>
        <Reveal delay={120}>
          <p className="mt-8 max-w-[680px] text-[var(--text-muted)] text-[17px] leading-[1.75]">
            Every brother in 2717, regardless of tier, receives the foundation below. Specifics scale with your application and the conversation we have together.
          </p>
        </Reveal>

        <div className="mt-20 grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--line)] border hairline">
          {INSIDE.map((item, i) => (
            <div key={item.n} className="group relative bg-[var(--bg)] p-8 md:p-10 min-h-[320px] flex flex-col justify-between overflow-hidden">
              <div className="absolute top-0 left-0 h-px w-0 bg-[var(--ember-2)] group-hover:w-full transition-all duration-700"></div>
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: "radial-gradient(400px 300px at 20% 0%, rgba(201,114,42,0.08), transparent 60%)" }}></div>
              <div className="relative">
                <div className="font-mono text-[11px] tracking-[0.24em] text-[var(--ember-3)]">{item.n}</div>
                <h3 className="font-display text-[28px] md:text-[32px] leading-[1.05] tracking-[-0.02em] mt-6 group-hover:text-[var(--ember-3)] transition-colors duration-500">{item.title}</h3>
              </div>
              <p className="relative text-[var(--text-muted)] text-[15px] leading-[1.7] mt-6">{item.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
